import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";

@Injectable()
export class DateUtils {

  /**
   * Format a Date object to "yyyy-mm-ddThh:MM:ss" string
   * @param Date
   */
  public dateToString1(date: Date): string {
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T" + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
  }

  /**
   * Format a Date object to "yyyy-mm-ddT00:00:00" string
   * @param Date
   */
  public dateToString2(date: Date): string {
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T00:00:00";
  }


  /**
   * Format a Date object to "yyyy-mm-ddThh:MM:ss" string
   * @param Date
   */
  public static dateToString3(date: Date): string {
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + " " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
  }

  /**
 * Format a Date object to "yyyy-mm-ddThh:MM" string
 * @param Date
 */
  public static dateToString5(date: Date): string {
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + " " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
  }

  /**
     * Convert a string UTC Date "yyyy-mm-ddThh:mm:ss" to local Date "yyyy-mm-ddThh:mm:ss"
     * @param dateStringUTC
     */
  public static stringUTCDateToLocalDate(dateStringUTC: string) {
    let dateUTCFormatted: string = dateStringUTC + 'z'
    let localDate = new Date(dateUTCFormatted);
    // console.log("DateString UTC: " + dateStringUTC + " to local date " + localDate);
    return this.dateToString3(localDate)
  }

  /**
  * Convert a string UTC Date "yyyy-mm-ddThh:mm:ss" to Date() object
   * @param dateStringUTC
   * @returns localDate as Date()
   */
  public static stringUTCDateToLocalDateObject(dateStringUTC: string) {
    let dateUTCFormatted: string = dateStringUTC + 'z'
    let localDate = new Date(dateUTCFormatted);
    return localDate
  }

  /**
     * Convert a string UTC Date "yyyy-mm-ddThh:mm:ss" to local Date "yyyy-mm-ddThh:mm:ss"
     * @param dateStringUTC
     */
  public static stringUTCDateToLocalDate5(dateStringUTC: string) {
    let dateUTCFormatted: string = dateStringUTC + 'z'
    let localDate = new Date(dateUTCFormatted);
    return this.dateToString5(localDate)
  }

  /**
       * Convert a string UTC Date "yyyy-mm-ddThh:mm:ss" to local Date e.g. "Mon Jan 01 2018 07:45:00 GTM +0100 (CET)" based on language selected by the user
       * @param dateStringUTC
       */
  public static stringUTCDateToLocalDate2(dateStringUTC: string) {
    let language = localStorage.getItem("Language")
    let dateUTCFormatted: string = dateStringUTC + 'z'
    let localDate = new Date(dateUTCFormatted);
    return new Intl.DateTimeFormat(language,
      {
        timeZoneName: 'longOffset',
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(localDate);
  }


  /**
   * Format a Date object to "yyyy-mm-ddT00:00:00" string
   * @param Date
   */
  public dateStringToString1(year: number, month: number, day: number): string {
    return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2) + "T00:00:00";
  }

  /**
   * Convert a string in format "yyyy-mm-ddT00:00:00" to local Date
   * @param dateString
   */
  public stringToLocalDate1(dateString: string) {
    return new Date(dateString + 'z');
  }

  diffHours(dateFrom, dateTo) {
    let diff = (dateTo.getTime() - dateFrom.getTime()) / 1000;
    diff /= (60 * 60);

    return Math.abs(Math.round(diff));
  }

  diffMinutes(dateFrom, dateTo) {
    let diff = (dateTo.getTime() - dateFrom.getTime()) / 1000;
    diff /= 60;

    return Math.abs(Math.round(diff));
  }

  /**
     * Convert string Local Time "yyyy-mm-ddThh:mm:ss" to UTC "yyyy-mm-ddThh:mm:ss"
     * @param localDateString
     */
  public static stringLocalDateToUTC(localDateString: string) {
    let localDate = new Date(localDateString);
    let utcDate = new Date(localDate.toUTCString());
    console.log("convert Local time:  " + localDateString + "  to  " + utcDate.toISOString().substring(0, 19) + "  UTC time")
    return utcDate.toISOString().substring(0, 19);
  }


  /**
   * Format a Date object to "yyyy-mm-dd"
   * @param Date
   */
  public static dateToString4(date: Date): string {
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
  }

  /**
     * Convert a string UTC Date "yyyy-mm-ddThh:mm:ss" to local Date "yyyy-mm-dd"
     * @param dateStringUTC
     */
  public static stringUTCDateToLocalDate3(dateStringUTC: string) {
    let dateUTCFormatted: string = dateStringUTC + 'z'
    let localDate = new Date(dateUTCFormatted);
    return this.dateToString3(localDate)
  }

  diffDays(dateFrom, dateTo) {
    let diff = (dateTo.getTime() - dateFrom.getTime()) / 1000;
    diff /= (60 * 60);

    return Math.abs(Math.round(diff));
  }

  /**
   * 
   * @param date Timestamp in format 2024-08-02 08:15:00.0
   * @returns timestamp in string in format 2024-08-02T08:15:00
   */
  public static stringDateToIso8601Type(date: string): string{
    return date.replace(" ", "T").replace(/\.0$/, "");
  }

  /**
   * 
   * @param date Timestamp in format 2024-08-02 08:15:00
   * @returns timestamp in string in format 2024-08-02T08:15:00
   */
  public static stringDateToIso8601Type1(date: string): string{
    return date.replace(" ", "T");
  }

  public static substract15Minutes(date: string): string{
    const newDate = new Date(date);
    newDate.setMinutes(newDate.getMinutes() - 15);
    return DateUtils.dateToString3(newDate);
  }

   /**
  * 
  * @param date ISO string in format 2024-08-02T08:15:00
  * @returns timestamp in format 2024-08-02 08:15:00.0
  */
  public static iso8601ToStringDate(date: string): string {
    return date.replace("T", " ");
  }

  public static iso8601ToStringDate2(date: string): string {
    return date.replace("T", " ").replace(".0", "");
  }
}
